import React from "react";
import classNames from "classnames";

import styles from "./ButtonIcon.module.scss";

interface ButtonIconProps {
    classes?: {
        root?: string;
        iconWrapper?: string;
        icon?: string;
    };
    disabled?: boolean;
    onClick: () => void;
    children: React.ReactElement<any>;
}

const ButtonIconWithCustomTouchArea = ({
    classes,
    disabled,
    onClick,
    children,
}: ButtonIconProps) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={classNames(styles["button-icon-touch-area"], classes?.root, {
                [styles["button-icon-touch-area--disabled"]]: disabled,
            })}
        >
            <span
                className={classNames(
                    styles["button-icon-touch-area__wrapper"],
                    classes?.iconWrapper,
                )}
            >
                {React.cloneElement(children, {
                    className: classNames(styles["button-icon-touch-area__icon"], classes?.icon),
                })}
            </span>
        </button>
    );
};
const ButtonIcon = ({ disabled, onClick, children, classes }: ButtonIconProps) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={classNames(styles["button-icon"], classes?.root, {
                [styles["button-icon--disabled"]]: disabled,
            })}
        >
            {React.cloneElement(children, {
                className: classNames(styles["button-icon__icon"], classes?.icon),
            })}
        </button>
    );
};

export { ButtonIconWithCustomTouchArea, ButtonIcon };
